import capitalizeWords from 'utils/capitalize-words';
import template from './rw-retailer-info.html';

const mapStateToThis = ({ config }) => {
  const { retailerDetailsFormat } = config;

  return {
    retailerDetailsFormat,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state')
class RwRetailerInfoController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  formatRetailerDetails(input = '') {
    if (this.retailerDetailsFormat === 'capitalize') {
      return capitalizeWords(input);
    }
    return input;
  }
}

export default class RwRetailerInfoComponent {
  constructor() {
    this.controller = RwRetailerInfoController;
    this.template = template;
    this.bindings = {
      retailer: '<',
      shortInfo: '<',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-retailer-info/rw-retailer-info-component.js